export const detectScrollBottom = (scrollElement) => {
	if ((scrollElement.current.clientHeight + scrollElement.current.scrollTop + 5) >= scrollElement.current.scrollHeight) {
		return true;
	} else return false;
}